import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css'],
  providers: [AuthService]
})
export class AuthComponent implements OnInit {
  errorMessage: string;
  auth : any = {};
  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit() {
    localStorage.removeItem('shop');
  }

  login() {
    this.authService.login(this.auth)
    .subscribe(
      (user) => {
        if (user.user !== false){
          localStorage.setItem('user', JSON.stringify(user.user));
          if (user.user.role != 3){
            this.router.navigate(['/']);
          }else{
            this.router.navigate(['technicalservice/list']);
          }
        }else{
          alert("Error!!")
        }
      },
      error =>  {
        this.errorMessage = <any>error;
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/auth/components/auth.component.ts